export default {
  delete_success: "L'offerta è stata eliminata con successo",
  delete_failed: "Eliminazione dell'offerta non riuscita",
  delete_confirm_title: 'Sei sicuro di voler eliminare questa offerta?',
  delete_last_day_confirm_title: "Rimuovendo l'ultimo giorno rimasto, questa offerta verrà eliminata. Vuoi continuare?",
  confirm: 'Conferma',
  cancel: 'Annulla',
  qualifying_items: 'Articoli idonei',
  free_items: 'Articoli gratuiti',
  all_day: 'Tutto il giorno',
  starts_on: 'Inizia il {{date}}',
  ends_on: 'Termina il {{date}}',
  ends_when_deleted: 'Termina quando eliminata',
  off: '{{amount}} di sconto',
  min_spend_value: 'Spesa minima: {{amount}}',
};
